import { trackEvent } from '~/features/analytics/track-event';
import {
  DIWALI_2026_ASSETS,
  DIWALI_2026_COLORS,
  DIWALI_2026_COPY,
  DIWALI_2026_CTA_LABEL,
  DIWALI_2026_EYEBROW_LABEL,
  getDiwali2026CheckoutHref,
} from '~/features/promotions/constants/diwali-2026';
import type { Diwali2026Variant } from '~/features/promotions/utils/get-diwali-2026-variant';

import type { PromoCampaignSurfaceRenderers } from '../types';

import { Diwali2026CatalogBanner } from './catalog-banner';
import { Diwali2026HomepageCard } from './homepage-card';

const DIWALI_2026_ANALYTICS_LABEL = 'diwali_2026_sale_clicked';

export const diwali2026CampaignSurfaces: PromoCampaignSurfaceRenderers<Diwali2026Variant>['surfaces'] = {
  homepage: ({ promoCode, imagePriority }) => (
    <Diwali2026HomepageCard
      checkoutHref={getDiwali2026CheckoutHref(promoCode)}
      imagePriority={imagePriority}
      onClick={() =>
        trackEvent({
          type: 'click',
          name: 'Homepage CTA Clicked',
          label: DIWALI_2026_ANALYTICS_LABEL,
        })
      }
    />
  ),
  catalog: ({ promoCode, imagePriority }) => (
    <Diwali2026CatalogBanner
      checkoutHref={getDiwali2026CheckoutHref(promoCode)}
      imagePriority={imagePriority}
      onClick={() =>
        trackEvent({
          type: 'click',
          name: 'Catalog Page CTA Clicked',
          label: DIWALI_2026_ANALYTICS_LABEL,
        })
      }
    />
  ),
  experience: ({ resolved, promoCode }) => ({
    id: `diwali_2026_${resolved}`,
    promoVariant: 'flash_sale',
    eyebrow: DIWALI_2026_EYEBROW_LABEL,
    title: DIWALI_2026_COPY.titleLine1,
    titleLine2: DIWALI_2026_COPY.titleLine2,
    description: DIWALI_2026_COPY.experienceSubtitle,
    ctaLabel: DIWALI_2026_CTA_LABEL,
    flashSale: {
      backgroundGradient: 'linear(to-b, black, black)',
      backgroundImage: DIWALI_2026_ASSETS.experienceAtfBg,
      backgroundImageMobile: DIWALI_2026_ASSETS.experienceAtfBgMobile,
      backgroundImageObjectPosition: 'center',
      bodyColor: DIWALI_2026_COLORS.accent,
      ctaBackgroundColor: DIWALI_2026_COLORS.cta,
      eyebrowColor: DIWALI_2026_COLORS.accent,
      ruleGradient: DIWALI_2026_COLORS.dividerGradient,
    },
    action: {
      type: 'link',
      href: getDiwali2026CheckoutHref(promoCode),
    },
  }),
};
